import type { SchemaType } from '@based/schema'
import { SchemaToType } from './utils'

export const PHASE_TYPES = {
  idea: 'idea',
  location: 'location',
  design: 'design',
  construction: 'construction',
  living: 'living',
} as const
export type PhaseType = keyof typeof PHASE_TYPES

export const phase = {
  uuid: { type: 'alias', format: 'UUID' },
  name: { type: 'text' },
  order: 'number',
  phaseType: Object.values(PHASE_TYPES),
  createdAt: { type: 'timestamp', on: 'create' },
  updatedAt: { type: 'timestamp', on: 'update' },
  initiatives: { items: { ref: 'initiative', prop: 'phase' } },
} satisfies SchemaType

export type Phase = SchemaToType<typeof phase> & {
  id: number
}
